import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	() =>
		createStyles({
			root: {
				height: "100vh",
				display: "flex",
				position: "fixed",
				overflow: "show",
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "rgba(0,0,0,0.4)",
				"& > div": {
					width: "120px !important",
					height: "120px !important"
				}
			},
			container: {
				position: "absolute",
				zIndex: 111111,
				backgroundColor: "rgba(0,0,0,0.4)"
			}
		}),
	{
		name: "LoadingPage",
		index: 1
	}
);

export default useStyles;
